// residency-route.matcher.ts
import { UrlSegment, UrlMatchResult } from '@angular/router';

export function residencyMatcher(segments: UrlSegment[]): UrlMatchResult | null {
    const path = segments.map(s => s.path).join('/');
    if (path.endsWith('-residency')) {
        return {
            consumed: segments,
            posParams: {
                fullPath: new UrlSegment(path, {})
            }
        };
    }
    return null;
}
